import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { isMobile } from '../../../utils/commonUtils';
import '../../../styles/LtsTrainDetailsTable.css';
import { LiveTrainStatusContext } from '../LiveTrainStatus';
import { getFontStyleForActual } from '../utils/ltsCardDetailsUtils';
import { TRAIN_DETAILS_LTS_TABLE } from '../constants/LtsConstants';

export function LtsTrainDetailsTable({ customClass, stationUrlsInterlinking }) {
  const isMobileDevice = isMobile();
  const { ltsPageState } = useContext(LiveTrainStatusContext);
  const { haltingStationCollection } = { ...ltsPageState };
  const {
    STATION_NAME,
    PLATFORM,
    ACTUAL_ARRIVAL,
    ACTUAL_DEPARTURE,
    HALT_TIME,
    SCHEDULED_ARRIVAL,
    SCHEDULED_DEPARTURE
  } = TRAIN_DETAILS_LTS_TABLE;
  return (
    <div className={`${customClass} ltsTrainDetailsTable`}>
      <div className="ltsTrainDetailsTable__header">
        <span className="stationName">{STATION_NAME}</span>
        <span className="platForm">{PLATFORM}</span>
        <span className="halt">{HALT_TIME}</span>
        <span className="schArrival">{SCHEDULED_ARRIVAL}</span>
        <span className={`schDeparture ${!isMobileDevice ? 'appendRight80' : 'appendRight40'}`}>
          {SCHEDULED_DEPARTURE}
        </span>
        <span className="actArrival">{ACTUAL_ARRIVAL}</span>
        <span className="actDeparture">{ACTUAL_DEPARTURE}</span>
      </div>
      <ul>
        {haltingStationCollection &&
          haltingStationCollection.map((haltingStation, index) => {
            const {
              stationName,
              stationCode,
              platformNumber,
              stoppingMinutes,
              actualDepartureDetails: { actualDepartureTime, actualDepartureDate } = {},
              scheduledDepartureDetails: { scheduledDepartureTime, scheduledDepartureDate } = {},
              actualArrivalDetails: { actualArrivalTime, actualArrivalDate } = {},
              scheduledArrivalDetails: { scheduledArrivalTime, scheduledArrivalDate } = {}
            } = haltingStation;
            return (
              <li key={index}>
                <a
                  href={stationUrlsInterlinking[stationCode]}
                  className={`stationName2 latoHeavy ${
                    !isMobileDevice ? 'font16 lineHeight20' : 'font14 lineHeight22'
                  }`}
                >
                  {stationName}
                </a>
                <span className="platForm">{platformNumber && platformNumber !== '0' ? platformNumber : '--'}</span>
                <span className="halt">{stoppingMinutes + ' min'}</span>
                <span className="schArrival">{scheduledArrivalTime}</span>
                <span className={`schDeparture ${!isMobileDevice ? 'appendRight80' : 'appendRight40'}`}>
                  {scheduledDepartureTime}
                </span>
                <span
                  className={`actArrival latoBold ${getFontStyleForActual({
                    scheduledDate: scheduledArrivalDate,
                    scheduledTime: scheduledArrivalTime,
                    actualDate: actualArrivalDate,
                    actualTime: actualArrivalTime
                  })}`}
                >
                  {actualArrivalTime}
                </span>
                <span
                  className={`actDeparture latoBold ${getFontStyleForActual({
                    scheduledDate: scheduledDepartureDate,
                    scheduledTime: scheduledDepartureTime,
                    actualDate: actualDepartureDate,
                    actualTime: actualDepartureTime
                  })}`}
                >
                  {actualDepartureTime}
                </span>
              </li>
            );
          })}
      </ul>
    </div>
  );
}

LtsTrainDetailsTable.propTypes = {
  customClass: PropTypes.string,
  ltsTrainDetails: PropTypes.array,
  stationUrlsInterlinking: PropTypes.object
};

export default LtsTrainDetailsTable;
